module.exports = __webpack_public_path__ + "img/menuIcon2.790f33c1.png";